<template>
  <div class="addressBook">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Address book</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewAddress"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new address
          </v-btn>
        </div>
        <v-card class="pa-2 adressesList" outlined tile>
          <v-data-table
            :headers="headers"
            v-model="selectedAddress"
            :items="addressesList"
            :loading="loading"
            :items-per-page="itemsPerPage"
            :single-select="true"
            item-key="AddressId"
            @click:row="rowClick"
            :page="currentPage"
            @update:page="onPageChange"
            dense
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedAddressExists" outlined dense type="info">
          Please select address or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form ref="addressForm" v-model="isFormValid" lazy-validation class="addressForm">
            <FormPanel :formElements="formElements" :readOnly="!isEditMode"></FormPanel>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedAddressExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
  </div>
</template>
<script>
import FormPanel from '@/components/FormPanel.vue';
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';

export default {
  name: 'AddressBook',
  components: {
    Dialog,
    FormPanel,
  },
  data() {
    return {
      loading: false,
      readOnly: true,
      isEditMode: false,
      dialog: false,
      formElements: [],
      allElements: [],
      addressesList: [],
      selectedAddress: [],
      count: 0,
      headers: [
        { text: 'Name', value: 'Name' },
        { text: 'Contact name', value: 'ContactName' },
      ],
      isFormValid: false,
      currentPage: 1,
      itemsPerPage: 15,
    };
  },
  mounted: function () {
    this.loadInitialFormData();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isSelectedAddressExists() {
      return this.selectedAddress && this.selectedAddress.length > 0;
    },
  },
  methods: {
    async loadInitialFormData(){
      await this.getForm('AddressBook');
      this.getAddressesList();
    },

    onAddNewAddress() {
      this.clearData();
      this.selectedAddress = [];
      this.isEditMode = true;
    },

    onPageChange(newPage){
      this.currentPage = newPage;
    },

    rowClick(item, row) {
      row.select(true);
      Utils.setDataToFormElements(item, this.formElements);
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedAddressExists)
        Utils.setDataToFormElements(this.selectedAddress[0], this.formElements);
      else this.clearData();
    },
    onDelete() {
      this.deleteAddress();
    },
    saveChanges() {
      const isFormValid = this.$refs.addressForm.validate();
      if (isFormValid) {
        if (this.isSelectedAddressExists) {
          this.updateAddress();
        } else {
          this.addNewAddress();
        }
      }
    },

    async getForm(formName) {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' + formName + '&planId=' + this.currentPlanId
        );
        this.allElements = response.data;
        if (response.data.length)
          this.formElements = response.data.filter((f) => f.Visible == true);

        this.getAddressesList();
      } catch (err) {
        console.error(err);
      }
    },

    async getAddressesList(addressId) {
      try {
        this.loading = true;
        let response = await this.$api.get('/AddressBook/GetAddressBookList');
        var data = response.data;
        this.addressesList = data;
        this.loading = false;
        const name = this.$route.query.name;
        if (addressId) {
          const selected = this.addressesList.find((x) => x.AddressId == addressId);
          if (selected) this.selectedAddress = [selected];
        } else if (name) {
          const selectedIndex = this.addressesList.findIndex(
            (x) => String(x.Name.toLowerCase().trim()) == String(name.toLowerCase().trim())
          );
          if (selectedIndex !== -1) {
            const selected = this.addressesList[selectedIndex];
            this.selectedAddress = [selected];
            this.currentPage = Math.floor(selectedIndex / this.itemsPerPage) + 1;
            Utils.setDataToFormElements(selected, this.formElements);
          }
          
        }
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },

    async addNewAddress() {
      const newAddress = {};
      this.allElements.forEach((el) => {
        newAddress[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newAddress[el.FieldName] = el.Value;
      });
      newAddress.AddressId = 0;
      try {
        const response = await this.$api.post('/AddressBook/UpdateAddressBook', newAddress);
        const data = response.data;

        this.getAddressesList(data.Value);
        this.isEditMode = false;
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateAddress() {
      try {
        const address = this.selectedAddress[0];
        this.formElements.forEach((el) => {
          address[el.FieldName] = el.Value;
        });
        await this.$api.post('/AddressBook/UpdateAddressBook', address);

        this.getAddressesList();
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },

    async deleteAddress() {
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record ?'
        );
        await this.$api.delete(
          '/AddressBook/DeleteAddressBook?AddressId=' + this.selectedAddress[0].AddressId
        );

        this.selectedAddress = [];
        this.clearData();
        this.getAddressesList();
      } catch (err) {
        console.error(err);
      }
    },

    clearData() {
      this.formElements.forEach(function (e) {
        e.Value = '';
      });
    },
  },
};
</script>
<style scoped>
.addressBook {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.addressBook .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.addressBook .formContainer .addressForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 10px;
}
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
